// removed by extract-text-webpack-plugin
module.exports = {"ui":"block_ui_9fw019","cube":"block_cube_2e679d","left":"block_left_edih2o","right":"block_right_2x7vc6","top":"block_top_dszstd","colorSide":"block_colorSide_8ls2zw","small":"block_small_acrf8x","tiny":"block_tiny_8g8jk5"};


//////////////////
// WEBPACK FOOTER
// ./packages/lib-ui/src/block/block.scss
// module id = 590
// module chunks = 0